<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-30 17:02:04
 * @LastEditors: geory
 * @LastEditTime: 2026-01-13 14:22:47
-->
<template>
  <div class="container">
    <menubar from="setting" />
    <div class="mainView">
      <div class="segment">
        <div
          :class="segIdx == 0 ? 'segmentItem segmentItemSel' : 'segmentItem'"
          @click="segItemClick(0)"
        >
          基础设置
        </div>
        <div
          :class="segIdx == 1 ? 'segmentItem segmentItemSel' : 'segmentItem'"
          @click="segItemClick(1)"
        >
          吸附设置
        </div>
        <div
          :class="segIdx == 2 ? 'segmentItem segmentItemSel' : 'segmentItem'"
          :style="{ borderRight: 'none' }"
          @click="segItemClick(2)"
        >
          逐条发送
        </div>
      </div>
      <div
        v-if="segIdx == 0"
        class="radioCellGroup"
      >
        <div class="radioCell">
          <div class="radioCellL">话术显示行数：</div>
          <el-radio-group
            v-model="settingInfo.wenanShowLineCount"
            @change="updateSetting"
          >
            <el-radio :label="1">最多显示1行内容</el-radio>
            <el-radio :label="3">最多显示3行内容</el-radio>
            <el-radio :label="-1">全部显示</el-radio>
          </el-radio-group>
        </div>
        <div class="radioCell">
          <div class="radioCellL">标题颜色：</div>
          <div class="radioCellR">
            <div
              v-for="(item, idx) in colorArr"
              :key="item"
              class="colorRaidoItem"
              :style="{ 'background-color': item }"
              @click="colorIdx = idx"
            >
              <img
                v-if="idx == colorIdx"
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092441.png"
              />
            </div>
          </div>
        </div>
        <div class="radioCell">
          <div class="radioCellL">话术详情：</div>
          <div
            class="radioCellR"
            @click="hoverPrviewChange"
          >
            <img
              class="radioCellRCheck"
              v-if="settingInfo && settingInfo.hoverPreviewCheck"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092417.png"
            />
            <img
              class="radioCellRCheck"
              v-else
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092352.png"
            />
            <div class="">鼠标停留3秒显示</div>
          </div>
        </div>
        <div class="radioCell">
          <div class="radioCellL">清理本地缓存：</div>
          <div
            class="radioCellR"
            @click="clearLocalData"
          >
            <el-button
              type="primary"
              icon="el-icon-delete"
              size="small"
            ></el-button>
          </div>
        </div>
        <div class="radioCell">
          <div class="radioCellL">语音快捷键：</div>
          <div class="shortcutArea">
            <input
              class="shortcutInput"
              :class="{ shortcutRecording: isRecordingKey, shortcutSuccess: shortcutJustSet }"
              readonly
              :value="displayText"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              @click="onShortcutActivate"
              @keydown.enter.prevent="onShortcutActivate"
              @keydown.space.prevent="onShortcutActivate"
              @focus="onShortcutFocus"
              @blur="onShortcutBlur"
            />
            <div
              v-if="shortcutError"
              class="shortcutError"
            >
              {{ shortcutError }}
            </div>
          </div>
        </div>
        <div
          v-if="cancelTopBtnShow"
          class="radioCell"
        >
          <div class="radioCellL">取消置顶：</div>
          <div
            class="radioCellR"
            @click="cancelTopChange"
          >
            <img
              class="radioCellRCheck"
              v-if="settingInfo && settingInfo.cancelTop"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092417.png"
            />
            <img
              class="radioCellRCheck"
              v-else
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092352.png"
            />
            <div class=""></div>
          </div>
        </div>
      </div>
      <div
        v-if="segIdx == 1"
        class="radioCellGroup"
      >
        <div class="radioCell">
          <div class="radioCellL">开启吸附：</div>
          <el-switch
            v-model="settingInfo.focusOpen"
            active-color="#ff4949"
            inactive-color="#ccc"
            @input="focusOpenChange"
          >
          </el-switch>
        </div>
        <div class="radioCell">
          <div class="radioCellL">列表吸附：</div>
          <el-radio-group
            v-model="settingInfo.adsorptionDirection"
            @change="updateSetting"
          >
            <el-radio :label="1">左侧</el-radio>
            <el-radio :label="2">右侧</el-radio>
          </el-radio-group>
        </div>
        <div
          class="radioCell"
          :style="{ 'align-items': 'start' }"
        >
          <div class="radioCellL">吸附应用：</div>
          <div
            class="radioCellR"
            :style="{ display: 'block' }"
          >
            <div class="radioCellRT">
              <div class="radioCellRTL">应用</div>
              <div class="radioCellRTR">吸附状态</div>
            </div>
            <div class="radioCellRB">
              <div
                v-if="!settingInfo.focusOpen"
                class="radioCellRBCover"
                @click="focusCoverClick"
              ></div>
              <div
                v-for="app in settingInfo.applist"
                :key="app.name"
                class="radioCellRBItem"
                @change="updateSetting"
              >
                <div class="radioCellRBL">
                  <img
                    class="radioCellRBLL"
                    :src="app.icon"
                  />
                  <div class="radioCellRBLR">{{ app.name }}</div>
                </div>
                <div class="radioCellRBR">
                  <el-radio-group v-model="app.focus">
                    <el-radio :label="true">启用</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="segIdx == 2"
        class="radioCellGroup"
      >
        <div class="radioCell">逐条发送(话术可选择)</div>
        <div class="radioCell radioCell2">分段设置</div>
        <div class="radioCell radioCell3">
          <div
            v-for="(item, idx) in settingInfo.partSplitType"
            :key="'partSplitType' + idx"
            class="radioCellR radioCellR2"
            @click="autoSendChange(idx)"
          >
            <img
              class="radioCellRCheck"
              v-if="item.checked"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092417.png"
            />
            <img
              class="radioCellRCheck"
              v-else
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20241030092352.png"
            />
            <div class="">{{ item.name }}</div>
          </div>
        </div>
        <div class="sep"></div>
        <div class="radioCell radioCell2">间隔时间设置</div>
        <div class="radioCell radioCell4">
          <div class="autoSendTypeItem">
            <el-radio
              v-model="settingInfo.spaceTimeType"
              label="1"
              @change="updateSetting"
              >智能间隔时间(模拟打字速度)</el-radio
            >
            <div v-if="settingInfo.spaceTimeType == '1'">
              <el-select
                v-model="settingInfo.letterSpaceTime"
                placeholder="请选择"
                :style="{ width: '75px', margin: '0 10px' }"
                @change="updateSetting"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                >
                </el-option> </el-select
              >秒/字<span
                v-if="settingInfo.letterSpaceTime == 0.1"
                :style="{ 'margin-left': '20px' }"
                >较快</span
              ><span
                v-else-if="settingInfo.letterSpaceTime == 0.5"
                :style="{ 'margin-left': '20px' }"
                >较慢</span
              >
            </div>
          </div>
          <div class="autoSendTypeItem">
            <el-radio
              v-model="settingInfo.spaceTimeType"
              label="2"
              @change="updateSetting"
              >自定义时间间隔(秒数)</el-radio
            >
            <div v-if="settingInfo.spaceTimeType == '2'">
              <el-input-number
                v-model="settingInfo.spaceTime"
                :min="1"
                size="small"
                label="描述文字"
                :style="{ 'margin-left': '50px' }"
                @change="updateSetting"
              ></el-input-number>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  MessageBox,
  Message,
  Radio,
  RadioGroup,
  Switch,
  Button,
  Select,
  Option,
  InputNumber,
} from "element-ui";
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(InputNumber);

import axios from "axios";
import menubar from "@/components/menubar";

export default {
  props: {
    from: {
      type: String,
    },
  },
  name: "Setting",
  data() {
    return {
      width: document.documentElement.clientWidth || document.body.clientWidth,
      height:
        document.documentElement.clientHeight || document.body.clientHeight,
      segIdx: 0,
      // wenanShowLineCount:0,
      colorArr: ["#FF6058", "#FFA000", "#43A046", "#69A3FB"],
      colorIdx: 0,
      adsorptionDirection: 1, //1左侧 2右侧
      // applist: [
      //   {
      //     name: "全部应用",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021152720.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "微信",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154220.png",
      //     focus: 1,
      //   },
      //   {
      //     name: "QQ",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154559.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "千牛",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154758.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "WhatsApp",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154831.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "Telegram",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154906.png",
      //     focus: 2,
      //   },
      //   {
      //     name: "企业微信",
      //     icon: "http://imgcuts.lingtuo.cn/A-8ba65907_20241021154936.png",
      //     focus: 2,
      //   },
      // ],
      settingInfo: {},
      cancelTopBtnShow: false,
      isRecordingKey: false,
      shortcutJustSet: false, // 刚设置成功，绿色闪一下
      shortcutError: "",
      // letterSpaceTime: 0.5,
      options: [
        {
          value: 0.1,
          label: "0.1秒/字",
        },
        {
          value: 0.2,
          label: "0.2秒/字",
        },
        {
          value: 0.3,
          label: "0.3秒/字",
        },
        {
          value: 0.4,
          label: "0.4秒/字",
        },
        {
          value: 0.5,
          label: "0.5秒/字",
        },
      ],
      // spaceTimeType: "1", //1.智能间隔时间(模拟打字速度) 2.自定义时间间隔(秒数)
      // spaceTime: 1,
      // partSplitType: [],
    };
  },
  components: {
    menubar,
  },
  computed: {
    displayText() {
      if (this.isRecordingKey) return "请按键…";
      return this.settingInfo?.voiceShortcut || "Fn";
    },
  },
  watch: {
    colorIdx() {
      this.settingInfo.color = this.colorArr[this.colorIdx];
      this.updateSetting();
    },
    // letterSpaceTime() {
    //   this.settingInfo.letterSpaceTime = this.letterSpaceTime;
    //   this.updateSetting();
    // },
    // spaceTimeType() {
    //   this.settingInfo.spaceTimeType = this.spaceTimeType;
    //   this.updateSetting();
    // },
    // spaceTime() {
    //   this.settingInfo.spaceTime = this.spaceTime;
    //   this.updateSetting();
    // },
    // partSplitType() {
    //   this.settingInfo.partSplitType = this.partSplitType;
    //   this.updateSetting();
    // },
  },
  activated() {},
  created() {
    // this.settingInfo = JSON.parse(localStorage.getItem("settingInfo"));
    // this.colorIdx = 0;
    // return;

    console.log("settting created...");
    if (window.require) {
      const { ipcRenderer } = window.require("electron");
      ipcRenderer.send("getSettingInfo");
      let _this = this;
      ipcRenderer.on("getSettingInfoResp", (event, settingInfo) => {
        console.log("getSettingInfoResp....");
        if (settingInfo) {
          console.log("settting getSettingInfoResp settingInfo:", settingInfo);
          _this.settingInfo = JSON.parse(settingInfo);
          // 旧版本升级：补上 voiceShortcut 默认值（用 $set 保证响应式）
          if (!_this.settingInfo.voiceShortcut) {
            _this.$set(_this.settingInfo, "voiceShortcut", "Fn");
          }
          if (_this.settingInfo && _this.settingInfo.version) {
            if (_this.isVersionLessThan("1.2.0", _this.settingInfo.version)) {
              _this.cancelTopBtnShow = true;
            }
          }
          _this.colorIdx = _this.colorArr.indexOf(_this.settingInfo.color);
          // _this.letterSpaceTime = _this.settingInfo.letterSpaceTime;
          // _this.spaceTimeType = _this.settingInfo.spaceTimeType;
          // _this.spaceTime = _this.settingInfo.spaceTime;
          // _this.timeSpace = _this.spaceTime * 1000;
          // _this.partSplitType = _this.settingInfo.partSplitType;
        }
      });
      ipcRenderer.on("settingWinShow", (event, from) => {
        if (from == "autoSend") {
          this.segIdx = 2;
        } else {
          this.segIdx = 0;
        }
      });
      // 引导页"快捷键设置" → 聚焦语音快捷键输入框
      ipcRenderer.on("setting-focus-shortcut", () => {
        this.$nextTick(() => {
          const el = this.$el.querySelector(".shortcutInput");
          if (el) el.focus();
        });
      });
      // 主进程检测到 Fn 键按下 → 录制 Fn 快捷键（不依赖合成键盘事件，回避 IME 问题）
      ipcRenderer.on("voice-shortcut-fn", () => {
        // 仅当快捷键录制区处于激活状态时才处理
        if (_this.isRecordingKey) {
          _this.setShortcut("Fn");
        }
      });
      // 主进程直接完成快捷键录制后通知 UI 更新
      ipcRenderer.on("shortcut-recorded", (_event, key) => {
        _this.isRecordingKey = false;
        _this.shortcutJustSet = true;
        _this.shortcutError = "";
        setTimeout(() => { _this.shortcutJustSet = false; }, 1500);
      });
      // 挂到 window 上供主进程 executeJavaScript 直接调用（备用路径）
      window.__setVoiceShortcut = (key) => {
        if (_this.isRecordingKey) {
          _this.setShortcut(key);
        }
      };
    }
  },
  methods: {
    isVersionLessThan(version, targetVersion) {
      // 将版本号拆分成主版本号、次版本号和修订号
      const [currentMajor, currentMinor, currentPatch] = version
        .split(".")
        .map(Number);
      const [targetMajor, targetMinor, targetPatch] = targetVersion
        .split(".")
        .map(Number);

      // 比较主版本号、次版本号和修订号
      if (currentMajor < targetMajor) {
        return true;
      } else if (currentMajor === targetMajor) {
        if (currentMinor < targetMinor) {
          return true;
        } else if (currentMinor === targetMinor) {
          return currentPatch < targetPatch;
        }
      }

      return false;
    },
    clearLocalData() {
      this.$confirm("是否确认清除本地缓存?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("clearLocalData");
      });
    },
    focusCoverClick() {
      this.$message({
        message: "请先开启吸附",
        type: "warning",
      });
    },
    focusOpenChange(checked) {
      this.settingInfo.focusOpen = checked;
      this.updateSetting();
    },
    cancelTopChange() {
      this.settingInfo.cancelTop = !this.settingInfo.cancelTop;
      this.updateSetting();
    },
    autoSendChange(itemIdx) {
      // this.partSplitType.forEach((item, idx) => {
      //   item.checked = idx === itemIdx;
      // });
      if (this.settingInfo.partSplitType[itemIdx].noCancel) {
        return;
      }
      this.settingInfo.partSplitType[itemIdx].checked = this.settingInfo
        .partSplitType[itemIdx].checked
        ? 0
        : 1;
      this.updateSetting();
    },
    hoverPrviewChange() {
      this.settingInfo.hoverPreviewCheck = !this.settingInfo.hoverPreviewCheck;
      this.updateSetting();
    },

    onShortcutActivate() {
      if (this.isRecordingKey) return;
      this.isRecordingKey = true;
      this.shortcutError = "";
      this.shortcutJustSet = false;
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("shortcut-recording-state", true);
      } catch (_) {}
    },

    onShortcutFocus() {
      this.shortcutError = "";
      this.shortcutJustSet = false;
    },

    onShortcutBlur() {
      if (!this.isRecordingKey) return;
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("shortcut-recording-state", false);
      } catch (_) {}
      setTimeout(() => {
        this.isRecordingKey = false;
        this.shortcutError = "";
        this.shortcutJustSet = false;
      }, 200);
    },

    setShortcut(key) {
      this.settingInfo.voiceShortcut = key;
      this.isRecordingKey = false;
      this.shortcutJustSet = true;
      this.shortcutError = "";
      this.updateSetting();
      // 1.5s 后恢复正常显示
      setTimeout(() => { this.shortcutJustSet = false; }, 1500);
    },
    segItemClick(idx) {
      this.segIdx = idx;
    },
    updateSetting() {
      // this.settingInfo.applist=this.applist;
      this.$store.commit("modifySettingInfo", this.settingInfo);
      const { ipcRenderer } = window.require("electron");
      ipcRenderer.send("saveSettingInfo", JSON.stringify(this.settingInfo));
    },
  },
};
</script>
<style>
body {
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
}

.el-radio {
  margin-right: 24px;
}

.el-radio__label {
  padding-left: 4px;
}
</style>
<style scoped>
.container {
}

.mainView {
  width: calc(100vw - 20px);
  min-height: calc(100vh - 86px);
  background-color: #e3e3e3;
  margin: auto;
  margin-top: 56px;
  padding-bottom: 20px;
  position: relative;
}

.segment {
  height: 24px;
  position: absolute;
  top: -12px;
  left: 50%;
  margin-left: -109px;
  background-color: #e3e3e3;
  border: 1px solid #c1c1c1;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
}

.segmentItem {
  width: 72px;
  height: 24px;
  background-color: #fff;
  background-image: unset;
  font-size: 12px;
  color: #3c3c3c;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #c1c1c1;
}

.segmentItemSel {
  background-image: linear-gradient(180deg, #69a3fb 0%, #096bff 100%);
  color: #fff;
}

.radioCellGroup {
  padding-top: 20px;
}

.radioCell4 {
  display: block !important;
  margin-top: 0px !important;
}

.radioCell3 {
  flex-wrap: wrap;
  margin-top: 0px !important;
}

.radioCell2 {
  font-size: 14px;
  color: #808080;
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.radioCell {
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-left: 82px;
}

.radioCellL {
  margin-right: 32px;
  width: 100px;
  text-align: right;
}

.radioCellR2 {
  margin-right: 78px;
}

.radioCellR {
  display: flex;
  align-items: center;
}

.radioCellRCheck {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.colorRaidoItem {
  width: 16px;
  height: 16px;
  border-radius: 16px;
  margin-right: 23px;
  border: 2px solid #e3e3e3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.colorRaidoItem img {
  width: 18px;
  height: 18px;
  display: flex;
}

.radioCellRT {
  width: 100%;
  height: 32px;
  background-color: #fff;
  display: flex;
  align-items: center;
  font-size: 12px;
}

.radioCellRTL {
  width: 180px;
  padding-left: 10px;
  font-size: 12px;
}

.radioCellRTR {
  width: 134px;
}

.radioCellRB {
  width: 324px;
  height: 296px;
  background-color: #f4f4f4;
  padding-top: 16px;
  position: relative;
}

.radioCellRBCover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 100;
  opacity: 0.8;
}

.radioCellRBItem {
  height: 32px;
  display: flex;
  margin-bottom: 8px;
}

.radioCellRBL {
  width: 180px;
  display: flex;
  align-items: center;
}

.radioCellRBLL {
  width: 32px;
  height: 32px;
  margin-left: 16px;
  margin-right: 8px;
}

.radioCellRBLR {
  font-size: 14px;
  color: #3c3c3c;
}

.radioCellRBR {
  width: 134px;
}

.sep {
  width: 74%;
  height: 1px;
  background-color: #c1c1c1;
  margin-top: 24px;
  margin-left: 13%;
}

.autoSendTypeItem {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.shortcutArea {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.shortcutInput {
  width: 130px;
  height: 32px;
  border: 1px solid #c1c1c1;
  border-radius: 4px;
  background: #fff;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #3c3c3c;
  cursor: pointer;
  outline: none;
  user-select: none;
  font-family: inherit;
  padding: 0;
  box-sizing: content-box;
}

.shortcutInput:focus {
  outline: none;
}

.shortcutInput.shortcutRecording {
  border-color: #096bff;
  box-shadow: 0 0 0 2px rgba(9, 107, 255, 0.2);
  animation: shortcutPulse 1.2s ease-in-out infinite;
}

@keyframes shortcutPulse {
  0%, 100% { box-shadow: 0 0 0 2px rgba(9, 107, 255, 0.2); }
  50%      { box-shadow: 0 0 0 4px rgba(9, 107, 255, 0.1); }
}

.shortcutHint {
  width: 100%;
  font-size: 11px;
  color: #999;
  margin-top: 4px;
  margin-left: 4px;
}

.shortcutError {
  width: 100%;
  font-size: 12px;
  color: #f56c6c;
  margin-top: 4px;
  margin-left: 4px;
}

.shortcutSuccess {
  border-color: #67c23a !important;
  box-shadow: 0 0 0 2px rgba(103, 194, 58, 0.25) !important;
  animation: none !important;
}

.shortcutSuccess::after {
  content: " ✓";
  color: #67c23a;
  font-weight: bold;
}
</style>
